import { render, staticRenderFns } from "./simOpenZb.vue?vue&type=template&id=268ed848&scoped=true&"
import script from "./simOpenZb.vue?vue&type=script&lang=js&"
export * from "./simOpenZb.vue?vue&type=script&lang=js&"
import style0 from "./simOpenZb.vue?vue&type=style&index=0&id=268ed848&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268ed848",
  null
  
)

export default component.exports